// src/Components/ProjectHighlight.js
import React from 'react';
import { usePreview } from '../context/PreviewContext';

export default function ProjectHighlight({ target, children }) {
  const { showPreview, hidePreview, updatePosition, selectProject } = usePreview();

  return (
    <span 
      className="global-hover-trigger"
      onMouseEnter={() => showPreview(target)}
      onMouseLeave={hidePreview}
      onMouseMove={updatePosition}
      /* GECORRIGEERD: We gebruiken onMouseDown in plaats van onClick.
         Dit kaapt de klik direct op de milliseconde en dwingt de navigatie af! */
      onMouseDown={() => selectProject(target)} 
      style={{ color: '#44B4D9', fontWeight: 700, cursor: 'pointer', display: 'inline-block' }}
    >
      {children || target}
    </span>
  );
}